import React, { useState, useEffect } from "react";
import { addStudentConvo, getConversationData, getConversationSummary } from "../../../../../Api/apiUtils";
import { toast } from "react-toastify";
import { TabContent, TabPane } from "reactstrap";
import { Button, DescriptionList, EmptyState, Field, Loader } from "../../../../../ui";
import { Actions, Dialog, Tabs, TextArea } from "../ui-pending";
import AiSummaryCard from "../../../Tasks/AiSummaryCard";
import { RM_TASKS_ENABLED } from "../../../../../Tasks/tasksApi";
import ChatbotWidget from "../chatbot/chatbotWidget";
import "./aiConvo.scss";


interface AddStudentChatsProps {
  studentProfileData: any;
  credentialId:any
  fullProfileData:any
}

const AddStudentChats: React.FC<AddStudentChatsProps> = ({ studentProfileData,  fullProfileData, credentialId }) => {
  console.log("stduentprofileDasta", fullProfileData)
  const [activeTab, setActiveTab] = useState<string>("conversation");
  const [comments, setComments] = useState("");
  const [conversationData, setConversationData] = useState<any[]>([]);
  const [aiSummaryData, setAiSummaryData] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);


  const profileData = JSON.parse(localStorage.getItem("profileData") || "{}");
  const formatSummary = (text: string) => {
    return text.split('\n').map((line, index) => {
      // Check if the line looks like a section header (e.g., starts with a number and **) 
      // or matches the section titles you expect.
      const isHeader = /^(\d+\))?\s*\*\*(.+)\*\*/.test(line.trim()) 
                       || /^(Executive Summary|Key Issues\/Themes|Suggested Next Actions|Risk\/Urgency)/i.test(line.trim());
      
      if (isHeader) {
        // Extract the text without asterisks if present
        const cleanLine = line.replace(/\*\*/g, '').trim();
        return (
          <React.Fragment key={index}>
            <strong>{cleanLine}</strong>
            <br />
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        );
      }
    });
  };
 
  

  useEffect(() => {
    // if (activeTab === "conversation") {
      fetchConversations();
    // } else if (activeTab === "aisummary") {
      fetchAiSummary();
    // }
  }, [studentProfileData.studentUserId, activeTab]);

  const fetchConversations = async () => {

    try {
      const response = await getConversationData(studentProfileData.studentUserId);
      if (response.success && response.data) {
        setConversationData(response.data);
      } else {
        setConversationData([]);
      }
    } catch (error) {
      toast.error("Failed to load conversation data");
    }
  };
  const fetchAiSummary = async () => {
    try {
      setIsLoading(true);
      const response = await getConversationSummary(studentProfileData.studentUserId);
      if (response.success && response.data) {
        setAiSummaryData(response.data.summary || JSON.stringify(response.data));
      } else {
        setAiSummaryData("No AI summary available.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error("Failed to load AI summary");
    }
  };
  

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleSave = async () => {
    setIsLoading(true);
    if (!comments.trim()) {
      toast.error("Please enter some comments");
      setIsLoading(false);
      return;
    }

    const payload = {
      userId: profileData.userId,
      userRole: profileData.role,
      user_Name:profileData.firstName,
      student_userId: studentProfileData.studentUserId,
      student_Name: studentProfileData.studentName,
      student_Course: studentProfileData.courseName,
      comments,
    };

    try {
      await addStudentConvo(payload);

      toast.success("Comment saved successfully");
      setIsLoading(false);

      setComments("");
      toggleModal(); // Close modal on successful save
      
      // Refresh conversations if on that tab
      if (activeTab === "conversation") {
        fetchConversations();
      }
    } catch (error) {
      toast.error("Failed to save comment");
      setIsLoading(false);
    }
  };

  return (
    <div className="ai-convo">
      <div className="ai-convo__sticky">
        <Tabs
          ariaLabel="Student notes"
          value={activeTab}
          onChange={toggleTab}
          items={[
            { id: "conversation", label: "Internal Notes" },
            { id: "aisummary", label: "AI Summary" },
            { id: "freshdesk", label: "Fresh Desk Summary" },
          ]}
        />

        {/* Add Comment button directly under the tabs but inside the sticky wrapper */}
        {activeTab === "conversation" && (
          <Actions align="start">
            <Button variant="primary" onClick={toggleModal}>
              Add Comment
            </Button>
          </Actions>
        )}
      </div>

      {/* Tab content area */}
      <TabContent activeTab={activeTab} className="ai-convo__content">
        <TabPane tabId="conversation">
          {/* Dialog for adding comment */}
          <Dialog
            isOpen={modalOpen}
            onClose={toggleModal}
            title="Add Comment"
            actions={
              <>
                <Button variant="secondary" onClick={toggleModal} disabled={isLoading}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={isLoading}>
                  Save
                </Button>
              </>
            }
          >
            <Field label="Comment">
              {(ctl) => (
                <TextArea
                  {...ctl}
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                  rows={5}
                  placeholder="Write your comments here"
                />
              )}
            </Field>
          </Dialog>

          {/* Comments list with vertical scroll inside the tab pane */}
          {conversationData.length === 0 ? (
            <EmptyState
              title="No comments yet"
              description="Use Add Comment to leave an internal note about this student."
            />
          ) : (
            <ul className="ai-convo__notes">
              {conversationData.map((item) => (
                <li key={item.id} className="ai-convo__note">
                  <div className="ai-convo__note-head">
                    <span className="ds-strong">Course: {item.student_Course}</span>
                    <span className="ai-convo__time ds-text-subtle">{new Date(item.createdAt).toLocaleString()}</span>
                  </div>
                  <DescriptionList
                    items={[
                      { label: "Artium User", value: item.user_Name },
                      { label: "Artium Role", value: item.userRole },
                    ]}
                  />
                  <p className="ai-convo__comment">{item.comments}</p>
                </li>
              ))}
            </ul>
          )}
        </TabPane>

        <TabPane tabId="aisummary">
          {/* The monthly cross-channel summary (support tickets, chat, calls,
              PTM notes, class ratings) — the same one RMs see on a ticket.
              Shown above the conversation summary below, which comes from a
              different source. */}
          <div className="ds-stack ai-convo__summaries">
            {RM_TASKS_ENABLED && studentProfileData?.studentUserId && (
              <section className="ai-convo__section">
                <h3 className="ai-convo__heading">Monthly summary — support history</h3>
                <AiSummaryCard
                  studentExternalId={String(studentProfileData.studentUserId)}
                  variant="history"
                  boxed={false}
                />
              </section>
            )}
            <section className="ai-convo__section">
              <h3 className="ai-convo__heading">Conversation summary</h3>
              {isLoading ? (
                <Loader label="Loading AI summary…" />
              ) : aiSummaryData ? (
                <div className="ai-convo__summary">{formatSummary(aiSummaryData)}</div>
              ) : (
                <EmptyState title="No AI summary available" description="A summary appears once this student has conversations on record." />
              )}
            </section>
          </div>
        </TabPane>

        <TabPane tabId="freshdesk">
          <div className="ai-convo__freshdesk">
            <ChatbotWidget
              isVisible={true} // Always visible inside the tab
              onClose={() => {}}
              initialEmail=""
              initialPhoneNumber={
                fullProfileData?.mobileNumber
                  ? `${fullProfileData.countryCode}${fullProfileData.mobileNumber}`
                  : ""
              }
              autoStart={true} // Automatically start fetching data
              isEmbedded={true} // Render as embedded widget
            />
          </div>
        </TabPane>
      </TabContent>
    </div>
  );
};

export default AddStudentChats;
